export enum AdminType {
    INSTRUCTOR = 0,
    ADMIN = 1,
}
